import algoliasearch, { SearchClient } from "algoliasearch";
import useSearchConfiguration from "src/hooks/algolia/useSearchConfigurations";
import { useEffect, useState } from "react";
import { createInMemoryCache } from "@algolia/cache-in-memory";
import { createConsoleLogger } from "@algolia/logger-console";
import { LogLevelEnum } from "@algolia/logger-common";
import { createFetchRequester } from "@algolia/requester-fetch";
import { AlgoliaSearchOptions } from "algoliasearch/dist/algoliasearch";

const useAlgoliaCreateClient = (): SearchClient | undefined => {
  const [client, setClient] = useState<SearchClient | undefined>();
  const { data, loading } = useSearchConfiguration();

  useEffect(() => {
    if (loading || client || !data?.searchConfigurationsWeb) {
      return;
    }

    const options: AlgoliaSearchOptions = {
      // Caches responses from Algolia
      responsesCache: createInMemoryCache(),
      // Caches Promises with the same request payload
      // requestsCache: createInMemoryCache({ serializable: false }),
      logger: createConsoleLogger(LogLevelEnum.Debug),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
      requester: createFetchRequester(),
    };

    const algoliaClient = algoliasearch(
      data?.searchConfigurationsWeb.app_id,
      data?.searchConfigurationsWeb.search_api_key,
      options
    );
    setClient(algoliaClient);
  }, [
    data?.searchConfigurationsWeb,
    data?.searchConfigurationsWeb.app_id,
    data?.searchConfigurationsWeb.search_api_key,
    loading,
    client,
  ]);

  return client;
};

export default useAlgoliaCreateClient;
